// import React from "react";

// const testimonials = [
//   { quote: "The Ask The Chart agent explained the dip perfectly. It was like talking to a coach!", author: "– Ravi M." },
//   { quote: "AI Narration helped me understand RSI divergence visually — finally!", author: "– Chloe T." },
//   { quote: "Smartest tool I’ve used since TradingView. Super beginner-friendly.", author: "– Leo K." },
// ];

// const AgentsTestimonialsSection = () => {
//   return (
//     <section className="testimonials">
//       <h2>Real Feedback from Real Traders</h2>
//       <div className="testimonial-cards">
//         {testimonials.map((t, index) => (
//           <div className="testimonial-card" key={index}>
//             <p>“{t.quote}”</p>
//             <em>{t.author}</em>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default AgentsTestimonialsSection;




import React from "react";

const stats = [
  { value: "10,000+", label: "Learners Empowered" },
  { value: "100,000+", label: "Lessons Completed" },
  { value: "4.8/5", label: "Average Rating" },
];

const testimonials = [
  { quote: "The Ask The Chart agent explained the dip perfectly. It was like talking to a coach!", author: "– Ravi M." },
  { quote: "AI Narration helped me understand RSI divergence visually — finally!", author: "– Chloe T." },
  { quote: "Smartest tool I’ve used since TradingView. Super beginner-friendly.", author: "– Leo K." },
];
const AgentsTestimonialsSection = () => (
  <section className="learners-section">
    <div className="container">
      <h2>Hear From Our Learners</h2>

      {/* <div className="stats-row">
        {stats.map((item, index) => (
          <div className="stat-box" key={index}>
            <div className="stat-number">{item.value}</div>
            <div className="stat-label">{item.label}</div>
          </div>
        ))}
      </div> */}

      <div className="testimonials-grid">
        {testimonials.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <p className="quote">“{item.quote}”</p>
            <p className="author"><strong>- {item.author}</strong></p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AgentsTestimonialsSection;

